module.exports = __webpack_public_path__ + "static/website-e1961cee2345027fc976ab6674477ffd.svg";